"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _useGuidedSellingStatus = require("../hooks/app/useGuidedSellingStatus");
var _useModalSize = require("../hooks/app/useModalSize");
var _BaseComponents = require("../components/StyledComponents/BaseComponents");
var _constants = require("../utils/constants");
var _uiSelectors = require("../store/ui/uiSelectors");
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
var _StickyFooter = _interopRequireDefault(require("./StickyFooter"));
var _useLocalTheme = _interopRequireDefault(require("../hooks/useLocalTheme"));
var _useAppSelector = require("../hooks/useAppSelector");
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LightBackgroundContainer = (0, _styledComponents.default)((0, _BaseComponents.LightBackground)('div'))`
  display: block !important;
`;
const RedBackgroundContainer = (0, _styledComponents.default)((0, _BaseComponents.RedBackground)('div'))(props => (0, _styledComponents.css)`
    display: block !important;
    padding: 10px !important;
    overflow: hidden;
    margin: ${props.margin}px;
  `);

/**
 * Modal component expects a react component child so this is
 * just a workaround to accommodate that requirement
 */
const ModalContent = _ref => {
  let {
    children,
    margin
  } = _ref;
  return (0, _useLocalTheme.default)('showRedBackGround', false) ? /*#__PURE__*/_react.default.createElement(RedBackgroundContainer, {
    margin: margin,
    className: "gs-app"
  }, children) : /*#__PURE__*/_react.default.createElement(LightBackgroundContainer, {
    className: "gs-app"
  }, children);
};
const GuidedSellingModal = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    isGuidedSellingModalOpen
  } = (0, _useGuidedSellingStatus.useGuidedSellingStatus)();
  const {
    currentModalSize,
    setModalSizeByName
  } = (0, _useModalSize.useModalSize)();
  const theme = (0, _core.useTheme)();
  const fullScreenMobile = (0, _useLocalTheme.default)('fullScreenMobile', false);
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const largeScreenMargin = (0, _useLocalTheme.default)('modalBody.largeScreenMargin', 0);
  const smallScreenMargin = (0, _useLocalTheme.default)('modalBody.smallScreenMargin', 0);
  const margin = breakpoints.sm ? smallScreenMargin : largeScreenMargin;
  const fullScreen = (0, _core.useMediaQuery)(theme.breakpoints.down('sm')) && fullScreenMobile;
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const maxModelSize = (0, _useConfig.default)('uiSettings.maxModalSize', currentModalSize);
  const enableShadowDOM = (0, _useConfig.default)('enableShadowDOM', false);
  const showStickyFooter = (0, _useConfig.default)('uiSettings.showStickyFooter', false);
  const FooterSelectorPrefix = showStickyFooter ? 'sticky' : 'normal';
  const useMUI = enableShadowDOM; //placeholder for future additional triggers (config, business logic, etc)
  (0, _react.useEffect)(() => {
    currentPage && setModalSizeByName(currentPage.toLowerCase());
  }, [currentPage]);
  const maxSize = _constants.MODAL_MAX_SIZES_OVERRIDE_SHADOWDOM[maxModelSize] || _constants.MODAL_MAX_SIZES_OVERRIDE_SHADOWDOM[currentModalSize] || 'md';

  // render on shadow DOM if exits
  let modalMountPoint = document.getElementById(_constants.APP_ROOT_ID);
  const shadow = document.getElementById(_constants.APP_ROOT_ID).shadowRoot;
  if (shadow) {
    const shadowRootContainer = shadow.getElementById(_constants.APP_SHADOW_DOM_ROOT_CONTAINER_ID);
    const modalMountPointId = 'gs-modal-portal';
    modalMountPoint = shadow.getElementById(modalMountPointId);
    if (!modalMountPoint) {
      modalMountPoint = document.createElement('section');
      modalMountPoint.id = modalMountPointId;
      shadowRootContainer.appendChild(modalMountPoint);
    }
  }
  return useMUI ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: isGuidedSellingModalOpen,
    fullWidth: true,
    fullScreen: fullScreen,
    disableEnforceFocus: true,
    maxWidth: maxSize,
    container: enableShadowDOM ? modalMountPoint : document.body,
    PaperProps: {
      style: {
        maxWidth: maxSize ? maxSize : '',
        margin: 3,
        maxHeight: fullScreen ? '100%' : '94%'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(ModalContent, null, /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    style: {
      padding: '20px 40px 40px'
    }
  }, /*#__PURE__*/_react.default.createElement(ModalContent, {
    margin: margin
  }, children)), /*#__PURE__*/_react.default.createElement(_StickyFooter.default, null)))) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.OverlayProvider, {
    zIndex: 9999
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Modal, {
    isOpen: isGuidedSellingModalOpen,
    isClosable: false,
    fullScreenOnSM: fullScreenMobile,
    size: 3,
    animate: true,
    srName: "app-modal",
    dataSelectorPrefix: FooterSelectorPrefix,
    footer: (0, _StickyFooter.default)()
  }, /*#__PURE__*/_react.default.createElement(ModalContent, {
    margin: margin
  }, children)));
};
var _default = GuidedSellingModal;
exports.default = _default;